var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"inner-content-wrapper"},[_c('inner-loading',{attrs:{"showing":_vm.loading}}),_c('div',{ref:"content",staticClass:"inner-content",style:({ 'min-height': _vm.minHeight })},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }